import { PublicPage, H2, P, UL } from "@/components/PublicPage";
import { BUSINESS, waLink } from "@/lib/site";

export default function PrivacyPolicy() {
  return (
    <PublicPage testid="privacy-page" overline="Kebijakan Privasi" title="Kebijakan Privasi">
      <P>Kebijakan ini menjelaskan data yang kami kumpulkan dan bagaimana kami menggunakannya saat
        Anda menggunakan Mas Tofa AI. Dengan menggunakan layanan, Anda menyetujui kebijakan ini.</P>

      <H2>Data yang Kami Kumpulkan</H2>
      <UL items={[
        "Data akun: nama dan email saat registrasi/login.",
        "Konten yang Anda unggah: foto produk dan foto model/karakter untuk pembuatan video.",
        "Video yang dihasilkan melalui layanan.",
        "Data kredit dan riwayat transaksi kredit.",
        "Informasi pembayaran untuk pembelian kredit, termasuk bukti transfer yang Anda unggah.",
        "Data teknis/log standar (mis. waktu akses) untuk keamanan dan pemeliharaan layanan.",
      ]} />

      <H2>Penggunaan Data</H2>
      <UL items={[
        "Menyediakan dan menjalankan fitur pembuatan video.",
        "Mengelola saldo kredit dan verifikasi pembayaran.",
        "Menjaga keamanan akun dan mencegah penyalahgunaan.",
        "Meningkatkan kualitas layanan.",
      ]} />

      <H2>Layanan Pihak Ketiga</H2>
      <P>Untuk menjalankan fitur tertentu, data yang relevan dapat diproses oleh penyedia berikut
        sesuai kebutuhan teknis:</P>
      <UL items={[
        "Penyedia AI untuk pembuatan konsep/teks (pemrosesan teks dan gambar produk).",
        "Penyedia AI untuk pembuatan gambar/video (pemrosesan gambar referensi untuk menghasilkan video).",
        "Penyimpanan objek (object storage) untuk menyimpan gambar referensi, bukti pembayaran, dan video.",
      ]} />
      <P>Kami hanya mengirimkan data yang diperlukan agar fitur dapat berjalan. Untuk pembayaran
        otomatis (mis. gateway pembayaran), data akan diproses hanya setelah metode tersebut
        diaktifkan dan diintegrasikan.</P>

      <H2>Penyimpanan & Keamanan</H2>
      <P>Data disimpan pada basis data dan penyimpanan objek kami. Bukti pembayaran dan aset Anda
        tidak dapat diakses publik; hanya dapat diakses oleh pemilik akun yang bersangkutan dan
        Admin yang berwenang untuk keperluan verifikasi.</P>

      <H2>Cookies / Penyimpanan Lokal</H2>
      <P>Kami menggunakan penyimpanan lokal peramban (local storage) untuk menyimpan token sesi
        agar Anda tetap masuk ke akun.</P>

      <H2>Hak Anda</H2>
      <P>Anda dapat menghubungi kami untuk pertanyaan terkait data akun Anda melalui WhatsApp Admin
        {" "}<a className="text-blue-600 hover:underline" href={waLink()} target="_blank" rel="noopener noreferrer">{BUSINESS.whatsappDisplay}</a>.</P>

      <H2>Perubahan Kebijakan</H2>
      <P>Kebijakan ini dapat diperbarui sewaktu-waktu. Perubahan akan ditampilkan pada halaman ini.</P>
    </PublicPage>
  );
}
